/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type InsuranceSlot = typeof InsuranceSlot[keyof typeof InsuranceSlot];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsuranceSlot = {
  Primary: 'Primary',
  PrimaryDME: 'PrimaryDME',
  Secondary: 'Secondary',
  Tertiary: 'Tertiary',
  Other: 'Other',
} as const;
